import { CIcon } from "@coreui/icons-react"
import { cilCenterFocus } from "@coreui/icons"
import { useTheme, resolveCategoryColor } from "../../utils/theme"
import "./RegionsNavigation.css"

const RegionsNavigation = ({ regions, onSelect, onReset, selectedRegion }) => {
  const { colors } = useTheme()

  return (
    <>
      <div className="regions-nav-floating">
        {Object.entries(regions).map(([code, region]) => {
          const isSelected = code === selectedRegion
          const regionColor = resolveCategoryColor(colors.regions, code, region.color)

          return (
            <button
              key={code}
              onClick={() => onSelect(code)}
              className={`region-pill${isSelected ? " is-selected" : ""}`}
              style={{
                "--region-color": regionColor,
              }}
            >
              <span className="region-pill-dot" />
              {region.name}
            </button>
          )
        })}
      </div>

      <button
        onClick={onReset}
        className="region-reset-btn-floating"
        title="Reset view"
        aria-label="Reset view"
      >
        <CIcon icon={cilCenterFocus} />
      </button>
    </>
  )
}

export default RegionsNavigation
